import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'

export const StyledTooltipContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: table;

  > * {
    display: table-row;
  }
`

export const StyledTooltipContentLeft = styled.div`
  display: table-cell;
  padding-right: 16px;
  vertical-align: middle;
`

export const StyledTooltipContentLeftItem = styled.div<{ mode: Theme }>`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ mode }) => sys[mode].text.primary};
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[12].size};
  line-height: ${sys.typescale[12].lineHeight};
`

export const StyledTooltipContentRight = styled.div`
  display: table-cell;
  text-align: right;
  vertical-align: middle;
`

export const StyledTooltipContentRightItem = styled.div<{ mode: Theme }>`
  color: ${({ mode }) => sys[mode].text.primary};
  font-weight: ${sys.fontWeight.semibold};
  font-size: ${sys.typescale[12].size};
  line-height: ${sys.typescale[12].lineHeight};
`
